module.exports = __webpack_public_path__ + "static/media/path0203.8971eff6.jpg";